<div class="full-height" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
  <app-order-info fxLayout="column" fxFlex [orderData]="plannedOrder"></app-order-info>
  <p class="b1 url warning" (click)="reconfirm()">{{ 'PLANNING.ACTIONS.RECONFIRM' | bmsTranslate }}</p>
  <mat-icon svgIcon="chevron-right" (click)="viewDetails()"></mat-icon>
</div>
